import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText } from '@keen.io/typography';
import { Input, Label, MousePositionedTooltip } from '@keen.io/ui-core';
import { colors } from '@keen.io/colors';
import { InputContainer } from './AxesTitles.styles';
import FieldGroup from '../FieldGroup';
import SettingsContainer from '../SettingsContainer';
import { AppContext } from '../../contexts';

var AxesTitles = function AxesTitles(_ref) {
  var xAxisTitle = _ref.xAxisTitle,
      yAxisTitle = _ref.yAxisTitle,
      settingsDisabled = _ref.settingsDisabled,
      onUpdateAxesTitles = _ref.onUpdateAxesTitles;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  return React.createElement(MousePositionedTooltip, {
    isActive: !!settingsDisabled,
    tooltipPortal: modalContainer,
    tooltipTheme: "dark",
    renderContent: function renderContent() {
      return React.createElement(BodyText, {
        variant: "body2",
        color: colors.white[500]
      }, settingsDisabled);
    }
  }, React.createElement(SettingsContainer, {
    isDisabled: !!settingsDisabled
  }, React.createElement(FieldGroup, {
    "data-testid": "x-axis-title"
  }, React.createElement(Label, {
    variant: "secondary"
  }, t('widget_customization_axis_settings.x_axis_title')), React.createElement(InputContainer, null, React.createElement(Input, {
    defaultValue: xAxisTitle,
    placeholder: t('widget_customization_axis_settings.x_axis_title_placeholder'),
    variant: "solid",
    onChange: function onChange(e) {
      return onUpdateAxesTitles({
        xAxisTitle: e.currentTarget.value,
        yAxisTitle: yAxisTitle
      });
    }
  }))), React.createElement(FieldGroup, {
    "data-testid": "y-axis-title"
  }, React.createElement(Label, {
    variant: "secondary"
  }, t('widget_customization_axis_settings.y_axis_title')), React.createElement(InputContainer, null, React.createElement(Input, {
    defaultValue: yAxisTitle,
    placeholder: t('widget_customization_axis_settings.y_axis_title_placeholder'),
    variant: "solid",
    onChange: function onChange(e) {
      return onUpdateAxesTitles({
        xAxisTitle: xAxisTitle,
        yAxisTitle: e.currentTarget.value
      });
    }
  })))));
};

export default AxesTitles;